// AI transparency page (IDD D-HP-SITE-031): the transparency duties of Art.\u00a050 of the AI Act (Regulation (EU)
// 2024/1689) as the company meets them, and the competent German authority. German is the authoritative version.
export const aiTransparencyPageBG = {
  seo: {
    title: 'Прозрачност относно ИИ | pAIoneer Labs GmbH',
    description: 'Как pAIoneer Labs GmbH използва изкуствен интелект и информира за това: асистент с ИИ, обозначаване на съдържание, генерирано с ИИ, редакционна отговорност и лице за контакт съгласно Акта за изкуствения интелект.',
    keywords: 'прозрачност относно ИИ, Акт за изкуствения интелект, AI Act, чл.\u00a050, обозначаване, асистент с ИИ, pAIoneer Labs GmbH',
    url: 'https://paioneer-labs.eu/ai-transparency',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Прозрачност относно ИИ',
      url: 'https://paioneer-labs.eu/ai-transparency',
      isPartOf: {
        '@type': 'WebSite',
        name: 'pAIoneer Labs GmbH',
        url: 'https://paioneer-labs.eu'
      }
    }
  },
  hero: {
    title: 'Прозрачност относно ИИ',
    subtitle: 'Как pAIoneer Labs GmbH използва изкуствен интелект и информира за това.'
  },
  sections: [
    {
      title: 'Правна рамка',
      paragraphs: [
        'От 2 август 2026 г. се прилагат задълженията за прозрачност по чл.\u00a050 от Регламент (ЕС) 2024/1689 относно изкуствения интелект (Акт за изкуствения интелект). В Германия съгласно KI-Marktüberwachungs- und Innovationsförderungsgesetz (KI-MIG, германски Закон за надзора на пазара на ИИ и насърчаването на иновациите) Bundesnetzagentur (Германската федерална агенция за мрежите) е органът за надзор на пазара и органът за жалби по Акта за изкуствения интелект.',
        'Тази страница описва кои системи с ИИ използва pAIoneer Labs GmbH и как информира за тях. Как се обработват при това личните данни, е описано в политиката за поверителност.'
      ]
    },
    {
      title: 'Асистент с ИИ в нашето приложение',
      paragraphs: [
        'В нашето приложение асистент с ИИ отговаря на Вашите въпроси. Той е система с ИИ: отговорите му се генерират автоматично от езикови модели и може да са неточни. Проверявайте важната информация, преди да основавате решения на нея.',
        'Приложението Ви уведомява за това преди първото Ви въвеждане и постоянно до чата (чл.\u00a050, параграф 1 от Акта за изкуствения интелект). Освен това всеки отговор на асистента е обозначен в машинночетим формат като генериран от ИИ (чл.\u00a050, параграф 2 от Акта за изкуствения интелект).',
        'Езиковите модели се предоставят чрез услугата на OpenRouter, Inc., САЩ.'
      ]
    },
    {
      title: 'Пряка комуникация със системи с ИИ',
      paragraphs: [
        'Когато система с ИИ на pAIoneer Labs GmbH комуникира пряко с Вас, например в чат, тя се представя като система с ИИ най-късно при първото взаимодействие.'
      ]
    },
    {
      title: 'Съдържание на този уебсайт',
      paragraphs: [
        'Текстовете на този уебсайт – включително когато инструменти с ИИ подпомагат създаването им – се проверяват от pAIoneer Labs GmbH и се публикуват под нейна редакционна отговорност (чл.\u00a050, параграф 4, втора алинея от Акта за изкуствения интелект).',
        'Съдържание под формата на изображения, звук или видео, което е генерирано или променено с ИИ и представя реални лица, места или събития по заблуждаващо реалистичен начин, обозначаваме като изкуствено генерирано или променено (чл.\u00a050, параграф 4, първа алинея от Акта за изкуствения интелект).'
      ]
    },
    {
      title: 'Анализ с машинно обучение',
      paragraphs: [
        'С Ваше съгласие анализираме статистиката на посещенията с методи на машинното обучение; подробности съдържа политиката за поверителност. При това не използваме нито разпознаване на емоции, нито биометрично категоризиране (чл.\u00a050, параграф 3 от Акта за изкуствения интелект). Разграничаването между хора и автоматизиран достъп се основава на технически характеристики на устройството, браузъра и връзката, а не на биометрични данни.'
      ]
    },
    {
      title: 'Жалба',
      paragraphs: [
        'Можете да подадете жалба относно възможно нарушение на Акта за изкуствения интелект до Bundesnetzagentur – органа за надзор на пазара и органа за жалби по Акта за изкуствения интелект в Германия. Тя предоставя информация по въпроса на bundesnetzagentur.de/ki.'
      ]
    }
  ],
  contact: {
    title: 'Контакт',
    description: 'С въпроси относно използването на изкуствен интелект можете да се свържете с нас по имейл.',
    email: 'info@paioneer.eu'
  },
  lastUpdated: 'Към 30 октомври 2026 г. Меродавна е версията на немски език.'
};
